import React, { useEffect, useState } from "react";
import {
  Box,
  Flex,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Select,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import {
  BLUEMONEDDBUTTONS,
  VARIANT,
  WHITE,
} from "../../../../constants/colors";
import { useRecoilState, useSetRecoilState } from "recoil";
import { useNavigate } from "react-router-dom";
import { componentState } from "../../../../atoms/componentState";
import FavoritesAPi from "../../../../services/favoritesApi";
import { Favorites } from "../../../../interfaces/defaultInterfaces";
import { LoggedUser } from "../../../../atoms/userLogged";
import { toast } from "react-toastify";
import { HamburgerIcon } from "@chakra-ui/icons";
import { FaEdit, FaTrash } from "react-icons/fa";
import { JWTToken } from "../../../vendas/listaDeVendas/components/SalesList";
import jwt_decode from "jwt-decode";
import ModalDeleteConfirmation from "./modalDeleteConfirmation";
import { refreshGlobal } from "../../../../atoms/refreshGlobal";
import { goToEditFavorecidos } from "../../../../routes/coordinator";
import { selectedClientHeader } from "../../../../atoms/selectedClientHeader";
import Pagination from "../../../../defaultComponents/pagination";

export default function FavoritesList() {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const initialValues = {
    clientFilter: 0,
    statusFilter: 0,
    saleTypeFilter: 0,
    initialDateFilter: "",
    finalDateFilter: "",
    minValueFilter: 0,
    maxValueFilter: 0,
  };
  const [filtros, setFiltros] = useState(initialValues);
  const [favoritesList, setFavoritesList] = useState(Array<Favorites>);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(0);

  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  const user = useRecoilState(LoggedUser)[0];
  const selectedIdClient = useRecoilState(selectedClientHeader)[0];
  const idUser =
    user.idLoginTipo === 4
      ? Number(jwtToken.idCliente)
      : Number(selectedIdClient);
  // const idUser = Number(jwtToken.idCliente);

  const navigate = useNavigate();
  const refresh = useRecoilState(refreshGlobal)[0];

  async function getFavoritesList() {
    try {
      setLoading(true);
      if (!search) {
        const response = await FavoritesAPi.getFavorecidosList(
          currentPage,
          pageSize,
          idUser
        );
        console.log(response.data);
        setFavoritesList(response.data);
        setPages(
          Math.ceil(Number(response.headers.totalamountofrecords) / pageSize)
        );
      } else {
        const response = await FavoritesAPi.getFavorecidosList(
          currentPage,
          pageSize,
          idUser
        );
        setFavoritesList(response.data);
        const lenght = response.data.length;
        setPages(Math.ceil(lenght / pageSize));
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
      toast.error("Não foi possível buscar a lista de favorecidos!");
    }
  }
  const onChangeSize = (e: any) => {
    setPageSize(e.target.value);
    setCurrentPage(1);
  };
  useEffect(() => {
    if (currentPage > pages) {
      setCurrentPage(1);
      getFavoritesList();
    }
  }, [pages]);
  useEffect(() => {
    getFavoritesList();
  }, [
    search,
    currentPage,
    pageSize,
    refresh,
    filtros.statusFilter,
    filtros.saleTypeFilter,
    filtros.clientFilter,
    filtros.initialDateFilter,
    filtros.finalDateFilter,
    filtros.minValueFilter,
    filtros.maxValueFilter,
    idUser,
  ]);
  const setHeaderLocation = useSetRecoilState(componentState);
  useEffect(() => {
    setHeaderLocation("Lista de Vendas");
  }, []);
  // const [clientList, setClientList] = useState(Array<ClientInterface>);
  // const [statusList, setStatusList] = useState(Array<statusInfo>);
  // const [modoPgtoList, setmodoPgtoList] = useState(Array<basicInfo>);
  // async function getClientList() {
  //     try {
  //         const response = await ClientApi.getClients(1, 100, "");
  //         setClientList(response.data);
  //     } catch (error) {
  //         console.log("error", error);
  //     }
  // }
  async function getStatusList() {
    try {
      // const response = await SystemApi.getTransacoesStatus();
      // setStatusList(response);
    } catch (error) {
      console.log("error", error);
    }
  }
  async function getModoPgtoList() {
    try {
      // const response = await SystemApi.getTransacoesModoPagamento();
      // setmodoPgtoList(response);
    } catch (error) {
      console.log("error", error);
    }
  }
  useEffect(() => {
    // getClientList();
    getStatusList();
    getModoPgtoList();
  }, []);

  return (
    <Flex w={"90%"} justifyContent={"center"} overflow={"hidden"}>
      <Box width={"100%"} height={"90%"} mt={"0.1%"} mx="auto" py={3} px={10}>
        <TableContainer borderRadius="8px" h={"85%"} overflowY="scroll">
          <Table variant="striped" colorScheme="gray" size="sm">
            <Thead h="60px" position="sticky" top="0" zIndex={2}>
              <Tr>
                <Th
                  w={"300px"}
                  borderRadius={"0 0 0 8px"}
                  textAlign={"center"}
                  bgColor={BLUEMONEDDBUTTONS}
                  color={WHITE}
                >
                  Nome do Titular
                </Th>
                <Th
                  w={"300px"}
                  textAlign={"center"}
                  bgColor={BLUEMONEDDBUTTONS}
                  color={WHITE}
                >
                  Tipo de Chave do Favorecido
                </Th>
                <Th
                  w={"300px"}
                  textAlign={"center"}
                  bgColor={BLUEMONEDDBUTTONS}
                  color={WHITE}
                >
                  Chave do Favorecido
                </Th>
                {/* <Th
                  w={"300px"}
                  textAlign={"center"}
                  bgColor={BLUEMONEDDBUTTONS}
                  color={WHITE}
                >
                  Tipo de Conta
                </Th> */}
                <Th
                  w={"300px"}
                  textAlign={"center"}
                  bgColor={BLUEMONEDDBUTTONS}
                  color={WHITE}
                >
                  Banco
                </Th>
                <Th
                  w={"300px"}
                  textAlign={"center"}
                  bgColor={BLUEMONEDDBUTTONS}
                  color={WHITE}
                >
                  Agência
                </Th>
                <Th
                  w={"300px"}
                  textAlign={"center"}
                  bgColor={BLUEMONEDDBUTTONS}
                  color={WHITE}
                >
                  Conta
                </Th>
                <Th
                  w={"300px"}
                  borderRadius={"0 0 8px 0"}
                  textAlign={"center"}
                  bgColor={BLUEMONEDDBUTTONS}
                  color={WHITE}
                >
                  Opções
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {favoritesList ? (
                favoritesList.map((item) => {
                  return (
                    <Tr key={item.id}>
                      {/* <Td textAlign={"center"}>
                                    {item.cliente?.isCnpj === true
                                        ? item.cliente.razaoSocial
                                        : `${item.cliente.nome} ${item.cliente.sobrenome}`}
                                    </Td> */}
                      <Td textAlign={"center"}>{item.nomeTitular || "-"}</Td>
                      <Td textAlign={"center"}>{item.tipoChave || "-"}</Td>
                      <Td textAlign={"center"}>{item.chavePix || "-"}</Td>
                      {/* <Td textAlign={"center"}>
                        {item.idTipoConta === 1 ? "Corrente" : "Poupança"}
                      </Td> */}
                      <Td textAlign={"center"}>{item.nroBanco || "-"} </Td>
                      <Td textAlign={"center"}>{item.nroAgencia || "-"}</Td>
                      <Td textAlign={"center"}>{`${item.nroConta}-${item.nroContaDigito}`}</Td>
                      <Td textAlign={"center"}>
                        <Menu>
                          <MenuButton
                            as={IconButton}
                            aria-label="Options"
                            icon={<HamburgerIcon />}
                            bgColor={BLUEMONEDDBUTTONS}
                            color={WHITE}
                            size={"sm"}
                          />
                          <MenuList>
                            <MenuItem
                              icon={<FaTrash />}
                              onClick={() => {
                                setIsOpen(true);
                                setSelectedId(item.id);
                              }}
                            >
                              Excluir
                            </MenuItem>
                            <MenuItem
                              icon={<FaEdit />}
                              onClick={() => {
                                goToEditFavorecidos(navigate, item.id);
                              }}
                            >
                              Editar
                            </MenuItem>
                          </MenuList>
                        </Menu>
                      </Td>
                    </Tr>
                  );
                })
              ) : (
                <Spinner size={"lg"} color={VARIANT} />
              )}
            </Tbody>
          </Table>
        </TableContainer>
        <ModalDeleteConfirmation
          setIsOpen={setIsOpen}
          isOpen={isOpen}
          id={selectedId}
        />
        <Flex width={"100%"} justifyContent="center" mt={8}>
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            pages={pages}
            pageSize={pageSize}
          />
          <Select
            value={pageSize}
            onChange={onChangeSize}
            size="sm"
            ml={5}
            maxW="70px"
            borderRadius="6px"
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={15}>15</option>
            <option value={25}>25</option>
          </Select>
        </Flex>
      </Box>
    </Flex>
  );
}
